import { z } from "zod";

import request from "../base-request";

const userSchema = z.object({
	id: z.string(),
	active: z.boolean(),
	company: z.object({
		id: z.string(),
		name: z.string(),
	}),
	manager: z
		.object({
			id: z.string(),
			name: z.string(),
		})
		.nullable(),
	directReports: z.array(z.string()).optional(),
	directReportData: z
		.array(
			z.object({
				id: z.string(),
				name: z.string(),
			})
		)
		.optional(),
	email: z.string(),
	jobTitle: z.string().or(z.array(z.string())).optional(),
	name: z.string(),
	phoneNumber: z.string().optional(),
});

export type User = z.infer<typeof userSchema>;

export const fetchUserInformation = async (userID: string) => {
	try {
		const [data] = await request<{ user_permissions: string[]; [key: string]: any }>(`/api/v0.1/users/${userID}/`);
		return userSchema.parse(data);
	} catch (error) {
		throw new Error("There was an error getting user information.");
	}
};
